export default __webpack_public_path__ + "static/media/Reimbursement History.48db4341.svg";